import { useState } from 'react'

import {
  Popover,
  LegacyPage,
  Json,
  Input,
  Form,
  Button,
} from 'peach/components'

const defaultValue = ['One', 'Two', '3', 'Four', 'five']

const ScratchOrderable = () => {
  const [state, setState] = useState(defaultValue)

  return (
    <LegacyPage.Centered>
      <Json.Table json={{ state }} title='State' />

      <Popover title='Boops' triggerLabel='Edit Boops'>
        <Form.Provider>
          <Input formKey='Foo' />
          <Input formKey='Bar' />
          <Input formKey='Baz' />
          <Input formKey='Bleep' />
          <Input formKey='Blorp' />
          <Input formKey='Boop' />
        </Form.Provider>
      </Popover>

      <Popover title='Actions' triggerLabel='Action Menu...'>
        <Button>Hello</Button>
        <Button>Goodbye</Button>
      </Popover>

      <Popover
        onApply={() => setState('Applied')}
        title='Roles'
        triggerLabel='Edit Roles'
        width='400px'
      >
        <Form.Provider>
          <Input formKey='Foo' />
          <Input formKey='Bar' />
          <Input formKey='Baz' />
          <Input formKey='Bleep' />
          <Input formKey='Blorp' />
          <Input formKey='Boop' />
        </Form.Provider>
      </Popover>
    </LegacyPage.Centered>
  )
}

export default ScratchOrderable
